module.exports = __webpack_public_path__ + "static/codenite_logo-c63183710abcf82587a9f5d818ab85e6.png";